import { DialogModule } from 'primeng/dialog';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { CommonModule, DOCUMENT } from '@angular/common';
import { GenericButtonComponent } from '../../../global/component/generic/generic-button/generic-button.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { Table, TableModule, TablePageEvent } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { InputTextModule } from 'primeng/inputtext';
import { FormControl, FormsModule } from '@angular/forms';
import { BatchService } from '../../services/donation-batch.service';
import { MenuItem, MessageService, SelectItem } from 'primeng/api';
import { GenericTextInputComponent } from '../../../global/component/generic/generic-text-input/generic-text-input.component';
import { InputGroupModule } from 'primeng/inputgroup';
import { MenuModule } from 'primeng/menu';
import { ToastModule } from 'primeng/toast';
import { LoadingSpinnerComponent } from '../../../global/component/loading-spinner/loading-spinner.component';
import { SelectListItem } from '../../models/DonationBatchModels';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { Router } from '@angular/router';
import { MatchType } from '../../../global/model/search/MatchType';

import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { SearchModel, DisplayColumn, LookupItem, LookupFilter, FilterModel } from '../../../global/model/SearchModel';
import { SearchService } from '../../../global/services/data/search-service/searchservice';
import { AddDonationService } from '../../../vortex/services/add-donation.service';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { DonorCardComponent } from '../../../vortex/page/donor-card/donor-card.component';
import { MainModel } from '../../../global/model/MainModel';
import { DonorAddComponent } from '../../../vortex/page/donor-add/donor-add.component';
import { DonorFundTotalsGridComponent } from '../../../vortex/shared-components/donor-fund-totals-grid/donor-fund-totals-grid.component';
import { Subscription } from 'rxjs';
import { DedupeDonor } from '../../../vortex/models/AddDonationModels';
import { DonorDedupeComponent } from '../../../vortex/page/donor-dedupe/donor-dedupe.component';
import { DonorService } from '../../services/donor.services';
import { SearchCacheService } from '../../services/searchcache.service';
import { catchError, of, tap } from 'rxjs';
import { exportToExcel } from '../../../global/util/util';
import Campaign from "../../../global/model/Campaign";

interface ExportColumn {
  title: string;
  dataKey: string;
}

@Component({
  selector: 'app-donor-search',
  standalone: true,
  imports: [TableModule, CommonModule, ButtonModule, DialogModule, FormsModule, MultiSelectModule, ToggleButtonModule, MenuModule, GenericButtonComponent, ToastModule,
    DonorCardComponent, TagModule, InputGroupModule, InputIconModule, IconFieldModule, CardModule, GenericTextInputComponent, LoadingSpinnerComponent, OverlayPanelModule,
    DonorAddComponent, DonorFundTotalsGridComponent, DonorDedupeComponent, InputTextModule],
  providers: [MessageService, AddDonationService],
  templateUrl: './donor-search.component.html',
  styleUrl: './donor-search.component.scss'
})
export class DonorSearchComponent {
  @ViewChild('resultTable')
  resultTable!: Table;
  // Arrays
  typeFilter: any[] = [];
  defaultColumns: DisplayColumn[] = [];
  selectedColumns: DisplayColumn[] = [];
  exportColumns: ExportColumn[] = [];
  lkpCheckboxes: LookupItem[] = [];
  groupedOptions: any[] = [];
  tableData: any[] = [];
  selectedOptions: MenuItem[] = [];
  dataElements: any[] = [];
  selectedStates: string[] = [];
  lkpstates: LookupItem[] = [];
  filters: string[] = [];
  selectedRows: any[] = [];
  dedupeDonors: DedupeDonor[] = [];

  // Booleans
  isExpanded = false;
  showLoading: boolean = false;
  isFullscreen: boolean = false;
  balanceFrozen: boolean = true;
  showScrollFilters: boolean = false;
  showDialog: boolean = false;
  showAddNewDonorDialog: boolean = false;
  showDonorGivingHistoryDialog: boolean = false;
  showDonorDedupeDialog: boolean = false;
  visibleDonorGivingHistory: boolean = false;

  campaignId: number = -1;
  showAddNewDonorButton: boolean = false;
  maxSelectedLabels = this.isExpanded ? 100 : 10;
  searchClicked: boolean = false;

  // Objects
  textFilters: { [key: string]: string } = {};
  columnData: SearchModel = {
    displayColumns: [],
    states: [],
    fundCodes: [],
    commonFilters: [],
    textFilters: [],
    rangeFilters: [],
    amountFilters: [],
    statusOptions: [],
    approvalOptions: [],
    fundraisers: [],
    sources: [],
    events: [],
    checkbooks: [],
    dateFilters: [],
    batchTypes: []
  };

  // Angular Specific (Decorators, Observables, Inputs/Outputs)
  @Output() cancelEvent = new EventEmitter<void>();
  dataObject!: Observable<unknown>;
  subscription: Subscription = new Subscription();

  // @Input() searchPageId: string = 'donor';
  // @Input() selectedSearchArea: any = null;
  @Input() searchKeyword: string = '';
  @Input() showInDialog: boolean = false;

  // Form Controls
  filterValue: FormControl = new FormControl('');

  // Other / Miscellaneous
  cols!: DisplayColumn[];
  defaultCmmonFilters: SelectItem[] = [];
  selectedDonorId: any;
  selectedDonorGivingHistoryDonorId = '';
  message: string = "No results available. Please adjust filters and try again.";
  searchMessage: string = "Try using Quick Search or updating the filters above to find your donors.";
  NoDataMessage: string = this.searchMessage;
  compareEnabled: boolean = false;
  isFilterActive: boolean = false;
  @Output() closeDonorSearch = new EventEmitter<void>();

  constructor(private donorService: DonorService,
    private messageService: MessageService,
    private searchService: SearchService,
    private searchCache: SearchCacheService,
    private mainModel: MainModel,
    private router: Router,
    @Inject(DOCUMENT) private document: Document) {
    this.fetchCampaignId();
  }

  private fetchCampaignId(): void {
    const selectedCampaign = this.mainModel.selectedCampaign();
    if (!selectedCampaign) {
      this.mainModel.fetchSelectedCampaign().subscribe({
        next: (campaign: Campaign) => {
          this.mainModel.setSelectedCampaign(campaign);
          this.campaignId = campaign.campaignId;
          this.loadDonorColumns().subscribe();
        },
        error: (err) => {
          console.error('Failed to fetch selected campaign:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to fetch the selected campaign. Please try again later.',
            life: 5000,
          });
        },
      });
    } else {
      this.campaignId = selectedCampaign.campaignId;
      this.loadDonorColumns().subscribe();
    }

    if (isNaN(this.campaignId as number)) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Invalid Campaign ID',
        detail: 'The selected campaign ID is invalid. Please select a valid campaign.',
        life: 5000,
      });
    }
  }

  ngOnInit() {
    this.filterValue.setValue(this.searchKeyword);

    this.loadDonorColumns().subscribe();
    this.subscription.add(
      this.searchService.showDonorsGivingHistory$.subscribe((value) => {
        if (value) {
          this.showDonorGivingHistoryDialog = true;
          this.selectedDonorGivingHistoryDonorId = value;
        }
      }));

    this.subscription.add(
      this.searchService.closeShowDonorGivingCompareDonors$.subscribe((value) => {
        if (value) {
          this.showDonorGivingHistoryDialog = false;
        }
      }));

    this.subscription.add(
      this.searchService.compareDonors$.subscribe((value) => {
        if (value) {
          console.debug(`Donor's Selected: ${value}`);
          this.showDonorDedupeDialog = true;
          this.dedupeDonors = value;
        }
      }));

    this.subscription.add(
      this.searchService.closeCompareDonors$.subscribe((value) => {
        if (value) {
          this.showDonorDedupeDialog = false;
        }
      }));
  }

  //#region onExportToExcel Click
  onExportToExcel() {
    const fields = this.selectedColumns.map(col => col.columnName);
    const dataToExport = this.resultTable.value.map(row => {
      const filteredRow: any = {};
      fields.forEach(field => {
        const value = row[field];
        filteredRow[field] = value !== undefined && value !== null ? value : '';
      });
      return filteredRow;
    });
    exportToExcel(dataToExport, "Donor Search");
  }
  //#endregion


  // Range Filters Code
  getBlankFilter(obj: any): FilterModel {
    let filterModel: FilterModel = new FilterModel();
    //filterModel.from = "";
    filterModel.op = "equals";
    if (obj.displayColumnType.columnType === "AmountFilter" ||
      obj.displayColumnType.columnType === "DateFilter") {
      filterModel.ops = [
        { label: 'Equals', value: 'Equals' },
        { label: 'Greater Than', value: 'gt' },
        { label: 'Greater Than Or Equal To', value: 'gte' },
        { label: 'Less Than', value: 'lt' },
        { label: 'Less Than Or Equal To', value: 'lte' },
        { label: 'Between', value: 'between' }
      ];
      filterModel.options = obj.options || [];
      filterModel.dataType = obj.displayColumnType.columnType === 'DateFilter' ? "date" : "number";

      delete obj.options;
      return filterModel as FilterModel;
    }
    return filterModel;
  }

  updateFilter(ref: any, att: string, val: any) {
    ref.filterModel[att] = (val.value ? val.value : val);
  }

  hideAllOpenOpMenus() {
    this.selectedColumns.forEach(
      (i: DisplayColumn) => {
        i.filterModel.isMenuOpen = false;
      }
    );
  }

  toggleMenu(col: DisplayColumn) {
    if (col.filterModel.isMenuOpen === false) {
      this.hideAllOpenOpMenus();
    }
    col.filterModel.isMenuOpen = !col.filterModel.isMenuOpen;
  }

  popupMenuClickHandler(col: DisplayColumn, op: any) {
    console.debug(1)
    col.filterModel.op = op.value;
    if (col.filterModel.op !== 'between') { col.filterModel.isMenuOpen = false }
  }
  // End of Range Filters
  private loadDonorColumns(): Observable<any> {
    return this.donorService.getDonorSearchColumnsAndFilters(this.campaignId).pipe(
      tap((data: SearchModel) => {
        this.columnData = data;
        this.defaultColumns = data && data.displayColumns ? data.displayColumns : [];

        // Reorder columns in the specified order
        const columnOrder = [
          'DonorID',
          'Organization',
          'FirstName',
          'LastName',
          'Address',
          'City',
          'State',
          'ZipCode',
          'HomePhone',
          'CellPhone'
        ];
        this.defaultColumns.sort((a, b) => columnOrder.indexOf(a.columnName) - columnOrder.indexOf(b.columnName));

        if (this.defaultColumns) {
          this.groupedOptions = this.groupColumnsBy('groupByColumn');
        }
        this.selectedColumns = this.defaultColumns.filter(x => x.isDefault);
        this.lkpstates = this.columnData && this.columnData.states || [];

        // Build range filter modelonorbatch
        data.displayColumns.forEach((i: DisplayColumn) => {
          i.filterModel = this.getBlankFilter(i);
        });

        this.cols = this.selectedColumns || [];
        this.exportColumns = this.cols.map((col: any) => ({ title: col.header, dataKey: col.field }));
      }),
      catchError(err => {
        console.error('Error loading donation batch columns:', err);
        return of(null);
      })
    );
  }

  groupColumnsBy(groupByField: keyof DisplayColumn) {
    const groups: any = {};
    this.defaultColumns.forEach(column => {
      const group = column[groupByField] as string;
      if (!groups[group]) {
        groups[group] = [];
      }
      groups[group].push(column);
    });

    return Object.keys(groups).map(group => ({
      label: group,
      items: groups[group]
    }));
  }

  hasNoResults = () => !this.tableData || this.tableData.length === 0;

  private convertLookupItemsToSelectItems(lookupItems: LookupFilter[]): SelectItem[] {
    return lookupItems.map((item: LookupFilter) => ({ value: item.value, label: item.label }));
  }

  onGlobalFilter(event: Event, table: any) {
    const input = event.target as HTMLInputElement;
    table.filterGlobal(input.value, 'contains');
  }
  ngAfterViewInit() {

    this.loadDonorColumns().subscribe(() => {
      const saved = this.searchCache.get('Donor-search');

      if (saved && saved.query) {
        const filters = saved.query;

        if (filters.MobilePhone) {
          filters.CellPhone = filters.MobilePhone;
          delete filters.MobilePhone;
        }
        this.isFilterActive = saved.isFilterActive;

        this.selectedStates = this.lkpstates
          .filter(s => filters['states']?.values?.includes(s.key))
          .map(s => s.value);

        for (const key in filters) {
          const filterEntry = filters[key];
          if (filterEntry && typeof filterEntry === 'object' && 'value' in filterEntry && 'matchMode' in filterEntry) {
            this.textFilters[key] = filterEntry.value ?? '';
          }
        }

        this.resultTable.filters = filters;
        this.onSearch();
      }
    });
    if (this.searchKeyword) {
      this.onSearch();
    }
  }

  onPageSearch() {
    if (!this.filterValue?.value?.trim()) {
      this.messageService.add({
        severity: 'error',
        summary: 'Missing Search Keyword',
        detail: 'Please enter a keyword in the quick search.',
      });
    }
    else
      this.onSearch();
  }

  getMatchMode(columnType: string): string {
    if (columnType === "TextFilter" || columnType === "IDFilter")
      return 'equals';
    if (columnType === "AmountFilter")
      return 'gt';
    else
      return 'startsWith'
  }

  toggleSelectedLabels() {
    this.isExpanded = !this.isExpanded;
    this.maxSelectedLabels = this.isExpanded ? 100 : 10;
    this.selectedColumns = [...this.selectedColumns];
  }

  pageForward() {
    (this.document.getElementsByClassName("p-paginator-next")[0] as HTMLAnchorElement).click()
  }

  pageBack() {
    (this.document.getElementsByClassName("p-paginator-prev")[0] as HTMLAnchorElement).click()
  }

  resetFilters() {

    this.resultTable.clear();
    this.textFilters = {};
    this.selectedStates = [];
    this.selectedRows = [];
    this.searchClicked= false
    this.tableData = [];
    this.NoDataMessage = this.searchMessage;

    this.selectedColumns.forEach(i => {
      if (i.filterModel.options?.length ||
        (i.displayColumnType.columnType === "AmountFilter" || i.displayColumnType.columnType === "DateFilter")) {
        i.filterModel.from = "";
        i.filterModel.to = "";
        i.filterModel.op = "equals";
      } else {
        i.filterModel.from = "";
        i.filterModel.to = "";
        i.filterModel.op = "contains";
      }
    });
    this.filterValue.patchValue(null);
    this.showAddNewDonorButton = false;
    this.isFilterActive = false;
    this.searchCache.clear('Donor-search');
  }

  private loadFilteredData(campaignId: number, filterData: string) {
    if (isNaN(campaignId) || campaignId <= 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid Campaign',
        detail: 'Please select a valid campaign before searching.',
        life: 5000,
      });
      return;
    }

    this.showLoading = true;
    this.tableData = [];
    this.donorService.searchDonors(campaignId, this.filterValue?.value ?? null,filterData ).subscribe({
      next: (data: any[] | null = null) => {
        this.showLoading = false;
        this.showAddNewDonorButton = true;

        if (data && data.length > 0) {
          data = data.map(item => ({
            ...item,
            Address: item.AddressLine1,
            Email: item.EmailAddress
          }));

          const records: Array<{ [key: string]: string }> = data;
          if (Object.values(records[0]).every((value) => value.trim() === "")) {
            this.NoDataMessage = this.searchClicked? this.message : this.searchMessage;
            data = null;
            this.tableData = [];
          } else {
            this.tableData = data;
            this.resultTable.reset();
          }
        }
        else
          this.NoDataMessage = this.searchClicked? this.message : this.searchMessage;

        // Reassigning Filter columns for persistency
        if ('MobilePhone' in this.textFilters) {
          this.textFilters['CellPhone'] = this.textFilters['MobilePhone'];
          delete this.textFilters['MobilePhone'];
        }
      },
      error: (error) => {
        this.showLoading = false;
        this.showAddNewDonorButton = false;
         // Reassigning Filter columns for persistency
         if ('MobilePhone' in this.textFilters) {
          this.textFilters['CellPhone'] = this.textFilters['MobilePhone'];
          delete this.textFilters['MobilePhone'];
        }
        console.error("API Error:", error);
        this.messageService.add({
          severity: 'error',
          summary: 'Unable to Load Data',
          detail: 'We were unable to retrieve data. Please try again or contact support if the issue continues.',
          life: 7500,
        });
      },
    });
  }

  private buildFilterData(filters: { [key: string]: any }): string {
    if (this.selectedStates && this.selectedStates.length > 0) {
      filters['states'] = {
        values: this.lkpstates
          .filter(state => this.selectedStates.includes(state.value))
          .map(state => state.key)
      };
    }
    else {
      filters['states'] = { values: [] };
    }

    //Rename column CellPhone as MobilePhone
    if ('CellPhone' in this.textFilters) {
      this.textFilters['MobilePhone'] = this.textFilters['CellPhone'];
      delete this.textFilters['CellPhone'];
    }

    // Text Filter
    for (const key in this.textFilters) {
      if (this.textFilters[key]?.trim()) {
        filters[key] = {
          value: this.textFilters[key].trim(),
          matchMode: 'contains'
        };
      } else {
        filters[key] = {
          value: null,
          matchMode: 'contains'
        };
      }
    }
      
    // Range Filter
    this.selectedColumns.forEach(
      (item: DisplayColumn) => {
        const { filterModel } = item;
        if (filterModel.from?.length) {
          const filter: MatchType = new MatchType();
          filter.Value = filterModel.from;
          filter.MatchMode = filterModel.op;
          if (filterModel.to) {
            filter.RangeEnd = filterModel.to;
          }
          filters[item.columnName] = filter;
        }
      }
    )
    this.searchCache.save('Donor-search', { query: filters, isFilterActive: this.isFilterActive });
    return JSON.stringify(filters);
  }

  onSearch() {
    this.showLoading = true;
    this.selectedRows = [];
    this.compareEnabled = false;
    const filterData = this.buildFilterData(this.resultTable.filters);
    const data = JSON.parse(filterData);
    const hasSearchTextFilter = !!this.filterValue?.value?.trim();
    const isEmptyStates = Array.isArray(data.states?.values) && data.states.values.length === 0;
    const isEmptyTextFilters = this.textFilters === null || Object.values(this.textFilters).every(value => value.trim() === '');

    if (!hasSearchTextFilter && isEmptyStates && isEmptyTextFilters) {
      this.messageService.add({
        severity: 'error',
        summary: 'Filter Required',
        detail: 'Please select at least one filter before starting the search.',
      });
      this.showLoading = false;
    } else {
      this.loadFilteredData(this.campaignId, filterData);
    }
  }

  onAddDonor(): void {
    if (!this.searchClicked) {
      this.showAddNewDonorDialog = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Action Required',
        detail: 'Please search for existing donors before adding a new one.',
      });
    } else
      this.showAddNewDonorDialog = true;
  }

  openDialog(donorId: any) {
    this.selectedDonorId = donorId;
    this.showDialog = true;
  }

  //#region onCompareDonors Click
  onCompareDonors() {
    if (this.selectedRows.length === 2) {
      this.searchService.emitCompareDonorsSelected(this.selectedRows);
    }
  }

  onRowSelect(event: any) {
    if (this.selectedRows.length > 2) {
      this.messageService.add({ severity: 'error', summary: 'Action Required', detail: 'You can only compare two donors at a time.' });
    }
    this.compareEnabled = this.selectedRows && this.selectedRows.length === 2;
  }

  onRowUnselect(event: any) {
    this.compareEnabled = this.selectedRows && this.selectedRows.length === 2;
  }

  isSingleDonorSelected(): boolean {
    return this.selectedRows.length === 1;
  }

  showDonorGivingHistory(rowData: any) {
    this.selectedDonorGivingHistoryDonorId = rowData.DonorID;
    this.showDonorGivingHistoryDialog = true;
  }

  openEditDonorDialog(rowData: any) {
    if (this.showInDialog) {
      this.selectedDonorId = rowData.DonorID;
      this.showDialog = true;
    }
    else {
      this.router.navigate(['/vortex/donors/card/' + rowData.DonorID]);
    }
  }
  isDisabledCheckbox(modelItem: any): boolean {
    return (this.selectedRows.length === 2 && this.selectedRows.indexOf(modelItem) === -1);
  }

  onSelectDonor(): void {
    if (this.selectedRows.length === 1) {
      this.searchService.emitDonorSelected(this.selectedRows[0]);
    } else if (this.selectedRows.length > 1) {
      this.messageService.add({ severity: 'error', summary: 'Action Required', detail: 'You can only select one donor at a time.' });
    }
  }

  closeDonorGivingHistory() {
    this.visibleDonorGivingHistory = false;
  }

  onCancel(): void {
    if (this.showInDialog) {
      this.cancelEvent.emit();
    }
    else {
      this.selectedRows = [];
      this.messageService.add({ severity: 'info', summary: 'Cancelled', detail: 'Selection cancelled.' });
    }
  }

  openAddDonorDialog(donorId: any) {
    this.selectedDonorId = donorId;
    this.showDialog = true;
  }

  hideDonorGivingHistoryDialog() {
    this.showDonorGivingHistoryDialog = false;
  }
  hideAddDonorDialog() {
    this.showAddNewDonorDialog = false;
  }

  onTableFilter(e: any) {
    const filters = this.resultTable.filters;
  }

  filterChanged() {
    const multiSelects = [
      this.selectedStates,
    ]
    const isMultiSelects = multiSelects.some(f => f && f.length > 0);
    const isTextFilters = Object.values(this.textFilters || {}).some(v => v && v.trim().length > 0);
    this.isFilterActive = isMultiSelects || isTextFilters || (typeof this.filterValue?.value === 'string' && this.filterValue.value.trim() !== '' );;
  }

  getSanitizedColumnName(col: any): string {
    return (col?.columnName || 'unknown').toLowerCase().replace(/\s+/g, '-');
  }

  handleDonorSaved(): void {
    this.showAddNewDonorDialog = false;
    this.messageService.add({
      severity: 'success',
      summary: 'Donor Saved',
      detail: 'The donor has been successfully added.',
    });
    this.closeDonorSearch.emit();
  }
}
